// Dev-only logger. En producción no imprime nada (React build DEV var).
// Uso: import { devLog } from '../lib/log'; devLog.error("...");
const isDev = process.env.NODE_ENV !== "production";

export const devLog = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
